import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true, // Primary auth: httpOnly secure session_token cookie
});

/**
 * Bearer token fallback used only when cookies are unavailable
 * (third-party-cookie blocks on some embedded contexts).
 * httpOnly cookie remains the primary; this is a degraded mode.
 */
export const setAuthHeader = (token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    try { localStorage.setItem("session_token", token); } catch { /* private mode */ }
  } else {
    delete api.defaults.headers.common.Authorization;
    try { localStorage.removeItem("session_token"); } catch { /* private mode */ }
  }
};

let savedToken = null;
try { savedToken = localStorage.getItem("session_token"); } catch { savedToken = null; }
if (savedToken) setAuthHeader(savedToken);
